module.exports = __webpack_public_path__ + "img/1_ileum.d88a5e2d.png";